import { useQuery } from '@tanstack/react-query'

import {
  getContainerDetails,
  getContainerCosts,
  getContainerDocuments,
  getContainerBatches,
  getContainerLogistics,
} from '@/api/containersAPI'

export function useContainerFullDetails(containerId: number) {
  return useQuery({
    queryKey: ['container-full-details', containerId],
    queryFn: async () => {
      const [details, costs, documents, batches, logistics] = await Promise.all(
        [
          getContainerDetails(containerId),
          getContainerCosts({ id: containerId }).catch(() => []),
          getContainerDocuments({ id: containerId }).catch(() => []),
          getContainerBatches(containerId).catch(() => []),
          getContainerLogistics(containerId).catch(() => null),
        ]
      )

      return {
        details,
        costs,
        documents,
        batches,
        logistics,
      }
    },
    enabled: !!containerId && containerId > 0,
    staleTime: 30 * 60 * 1000,
    gcTime: 45 * 60 * 1000,
  })
}
